import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
const WHOIS_AVAILABILITY_SPEC = 'specs.premium.domains.gateWhoIsAvailbility';
export const getWhoisAvailability = async _ref => {
  let httpClient = _ref.httpClient,
    domainName = _ref.request.domainName;
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    experiments = _ref2.experiments,
    referralAdditionalInfo = _ref2.referralAdditionalInfo;
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    getWhoisAvailabilityBase = _await$dynamicLoadApi.getWhoisAvailabilityBase,
    domainsLogger = _await$dynamicLoadApi.domainsLogger;
  const isEnabled = experiments == null ? void 0 : experiments[WHOIS_AVAILABILITY_SPEC];

  // If the experiment is enabled, we return true for all domains like in the old concierge behavior
  if (isEnabled) {
    return {
      isTaken: true
    };
  }
  const _await$getWhoisAvaila = await getWhoisAvailabilityBase({
      domainName
    }),
    isTaken = _await$getWhoisAvaila.isTaken;
  domainsLogger({
    entity: 'getWhoisAvailability',
    type: 'info',
    message: 'getWhoisAvailability result',
    referralAdditionalInfo,
    metadata: {
      domainName,
      isTaken
    }
  });
  return {
    isTaken
  };
};
//# sourceMappingURL=getWhoisAvailability.js.map